// Define a type for the data
type Node = {
  id: number;
  name: string;
  type: string;
  currentFwVersion: string;
  lastFwVersion: string;
  lastUpdatedDate: string;
  configUpdateStatus: string;
  otaUpdateStatus: string;
  firmwareType: string;
  entity: number;
  ranch: number;
  block: number;
};


// Sample nodes data
const sampleData: Node[] = [
  {
    id: 1,
    name: 'CN-1',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 739865,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 2,
    name: 'CN-2',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'in progress',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 735701,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 3,
    name: 'FN-1',
    type: 'field-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 739865,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 4,
    name: 'FN-2',
    type: 'field-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'in progress',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 735701,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 5,
    name: 'CN-3',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 735702,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 6,
    name: 'FN-3',
    type: 'field-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'wireless',
    block: 735702,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 7,
    name: 'CN-4',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'in progress',
    firmwareType: 'application',
    block: 735703,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 8,
    name: 'CN-5',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'in progress',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 735704,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 9,
    name: 'FN-5',
    type: 'field-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 739866,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 10,
    name: 'CN-6',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'application',
    block: 735704,
    ranch: 73570,
    entity: 7357,
  },
  {
    id: 11,
    name: 'CN-7',
    type: 'control-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'wireless',
    block: 739876,
    ranch: 74137,
    entity: 26,
  },
  {
    id: 12,
    name: 'FN-6',
    type: 'field-node',
    currentFwVersion: '1.1.0',
    lastFwVersion: '1.0.0',
    lastUpdatedDate: '2025-01-01T13:10:00Z',
    configUpdateStatus: 'completed',
    otaUpdateStatus: 'completed',
    firmwareType: 'wireless',
    block: 739874,
    ranch: 74137,
    entity: 26,
  },
];

export default sampleData;
